import React, { useContext } from 'react'
import { Select, MenuItem, InputLabel, FormControl, TextField, Autocomplete } from '@mui/material'
import { LoadingContext } from '../M_Utils'
import { useTranslation } from 'react-i18next'

export function M_Select({ label, value, options, color, secondColor,
    disabled, required, onChange, onClick, multiple, minWidth,
    itemTemplate, height, margin, padding, fontSize, marginLeft,
    marginRight, size, autocomplete, onChangeValue, hasNone, translate, disabledColor }) {

    const ctx = useContext(LoadingContext)
    const { t } = useTranslation()

    color = color ? color : ctx.primaryColor ? ctx.primaryColor : 'var(--color-black)'
    secondColor = secondColor ? secondColor : ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)'

    const styles = {
        // height: height,
        margin: margin,
        width: size ? size : null,
        // '&.MuiInput-sizeSmall': {padding:'0px'},
        marginLeft: marginLeft,
        marginRight: marginRight,
        '& label': { color: secondColor ? secondColor : 'var(--color-black)', },
        '& label.Mui-focused': { color: secondColor ? secondColor : 'var(--color-black)' },
        '& .MuiInput-underline:after': { borderBottomColor: color ? color : 'var(--color-black)' },
        "& .MuiInputBase-root.Mui-disabled": {
            "& > fieldset": {
                borderColor: disabledColor ? disabledColor : 'rgba(0, 0, 0, 0.38) !important'
            }
        },
        '& .MuiOutlinedInput-input': {
            backgroundColor: 'var(--color-white)',
            padding: padding,
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: color ? color : 'var(--color-black)',
                width: size ? size : 'auto',
                height: height,
            },
            '&:hover fieldset': {
                borderColor: color ? color : 'var(--color-black)',
            },
            '&.Mui-focused fieldset': {
                borderColor: color ? color : 'var(--color-black)',
                boxShadow: `2px 2px 2px ${color}`
            },
            "& legend": {
                letterSpacing: -1.9,
            }
        },
    }

    return (
        <>{autocomplete ?
            <Autocomplete
                id="combo-box-demo"
                options={translate && options.map(element => { return { ...element, label: t(element.label) } }) || options}
                sx={styles}
                getOptionLabel={(e) => {
                    return e?.label || ''
                }}
                getOptionKey={(e) => {
                    return e.Id
                }}
                multiple={multiple}
                value={value}
                onChange={(event, value, reason) => onChangeValue(value)}
                // onInputChange={(e,o,p) => {console.log(e,o,p)}}
                renderInput={(params) => <TextField
                    {...params}
                    slotProps={{
                        inputLabel: { shrink: true }
                    }}
                    // onChange={onChange}
                    margin="dense"
                    required={required}
                    label={translate && t(label) || label}
                    variant="outlined"
                    // InputProps={{ ...params.InputProps }}
                    // inputProps={{
                    //     ...params.inputProps,
                    //     autoComplete: 'new-password',
                    // }}
                    style={{ height: height, textOverflow: 'ellipsis' }}
                    sx={styles}
                    size="small"
                    id="margin-none"
                />}
            />
            : <FormControl
                sx={{
                    margin: margin,
                    marginLeft: marginLeft,
                    marginRight: marginRight,
                    '& label': { color: disabled ? 'rgba(0, 0, 0, 0.38)' : secondColor ? secondColor : 'var(--color-black)' },
                    '& label.Mui-focused': { color: secondColor ? secondColor : 'var(--color-black)' },
                    '& .MuiInput-underline:after': { color: color ? color : 'var(--color-black)', borderColor: "transparent" },
                    "& .MuiInputBase-root.Mui-disabled": {
                        "& > fieldset": {

                            borderColor: 'rgba(0, 0, 0, 0.38) !important'
                        },
                    },
                    '& .MuiOutlinedInput-root': {
                        height: height,
                        fontSize: fontSize,
                        padding: padding,
                        '& fieldset': {
                            borderColor: color ? color : 'var(--color-black)',
                        },
                        '&:hover fieldset': {
                            borderColor: color ? color : 'var(--color-black)',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: color ? color : 'var(--color-black)',
                            boxShadow: `2px 2px 2px ${color}`
                        },
                    },
                    minWidth: minWidth,
                }}
                margin="dense"
                fullWidth
                size='small'
                required={required}
                id="margin-none"
            >
                <InputLabel>{translate && t(label) || label}</InputLabel>
                <Select
                    label={translate && t(label) || label}
                    value={value}
                    disabled={disabled}
                    required={required}
                    onChange={onChange}
                    multiple={multiple}
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                maxHeight: 155,
                                "& .Mui-selected": {
                                    backgroundColor: "var(--color-grey-light)",
                                    height: height
                                },
                                "& .Mui-selected:hover": {
                                    backgroundColor: "var(--color-grey-light)"
                                },
                            }
                        }
                    }}
                >
                    {!hasNone && <MenuItem value="" onClick={() => onClick ? onClick({}) : {}}  > <em>None</em> </MenuItem>}
                    {options.map((el, index) => (
                        <MenuItem key={index} disableRipple={true} value={el.value} onClick={() => onClick ? onClick(el) : {}}  > {itemTemplate ? itemTemplate(el) : el.label} </MenuItem>
                    ))}
                </Select>
            </FormControl>}
        </>
    )
}
